import React from 'react';
import { Separator } from 'seduo-ui';
const Example = () => (<div className="text-center">
        <p>some text</p>
        <Separator />
        <p>another text</p>
    </div>);
export default Example;
